import Link from 'next/link';
import type { MouseEvent } from 'react';
import { useBasePath } from '../../lib/use-base-path';
import { routeLink } from '../../lib/route-link';
import { Typography } from './ui';
import { UnreadDisc } from './home3/Home3Categories';
import home3 from './home3/Home3Categories.module.css';
import styles from './SpaceCategoryTile.module.css';

export type SpaceCategory = 'tasks' | 'goals' | 'routines' | 'files' | 'apps' | 'calendar';

/**
 * One category of a Space (Space rules spec 2026-10-29, behind `symphonySpaceCardV2`): THE SAME tile Home's category
 * row draws (`Home3Categories` — its 60x60 box, its art from `public/illustrations/home3/`, its unread disc and its
 * label), as a link to that page on Home filtered to this Space. `count` is what is new there since the reader last
 * looked; 0 draws no disc.
 */
export function SpaceCategoryTile({
  category,
  label,
  count,
  href,
  onClick,
  testId,
}: {
  category: SpaceCategory;
  label: string;
  count: number;
  href: string;
  onClick: (e: MouseEvent<HTMLAnchorElement>) => void;
  testId: string;
}) {
  const basePath = useBasePath();
  const link = routeLink(basePath, href);
  return (
    <Link href={link.href} as={link.as} className={`${home3.cat} ${styles.tile}`} data-testid={testId} onClick={onClick}>
      <span className={home3.tile}>
        <span className={home3.art}>
          <img src={`${basePath}/illustrations/home3/${category}.svg`} alt="" width={40} height={40} />
        </span>
        <UnreadDisc count={count} />
      </span>
      <Typography variant="p3" color="secondary" component="span" className={home3.label} noWrap>
        {label}
      </Typography>
    </Link>
  );
}
